import React, { useEffect, useState } from 'react';
import { TextInput, Text, View } from 'react-native';
import { func } from 'prop-types';
import { t } from 'Locale';
import theme from 'Theme';
import { useStore } from 'Store';
import { ActivityIndicator, CustomKeyboardAvoidingView } from 'LocalGluons';
import { logEvent } from 'AppManager/';
import SendCode from './SendCode';

import defaultStyles from '../PageStyles.jss';
import { use } from 'i18next';

const SendCodePassword = ({ onSubmitted, close }) => {
    const { appManager, setHideLoginHeader } = useStore();
    const [username, setUsername] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(false);

    const onGetVerificationCode = async () => {
        setLoading(true);
        try {
            await appManager.api.resetPassword({ loginOrNickname: username });
            onSubmitted({ loginOrNickname: username });
        } catch (err) {
            setErrorMessage(err.localizedMessage);
        } finally {
            setLoading(false);
            logEvent({
                type: 'general',
                subtype: 'forgotPassword'
            });
        }
    };

    return (
        <CustomKeyboardAvoidingView>
            <SendCode
                title={t('COMMON.RESET_FORGOTTEN_PASSWORD')}
                description={t('LOGIN.FORGOTTEN_PASSWORD_DESCRIPTION')}
                onGetVerificationCode={onGetVerificationCode}
                errorMessage={errorMessage}
                buttonDisabled={!username.trim()}
                close={close}
            >
                <View style={defaultStyles.inputWidth}>
                    <TextInput
                        style={defaultStyles.input}
                        placeholder={t('COMMON.USERNAME')}
                        placeholderTextColor={theme.placeholderTextColor}
                        onChangeText={setUsername}
                        autoCapitalize="none"
                        value={username}
                        returnKeyType="done"
                        onSubmitEditing={onGetVerificationCode}
                        testID="username_input"
                    />
                </View>
            </SendCode>
            {loading && <ActivityIndicator isOverlay />}
        </CustomKeyboardAvoidingView>
    );
};

SendCodePassword.propTypes = {
    onSubmitted: func.isRequired
};

export default SendCodePassword;
